var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { status } from '../theme/color';
const StyledDot = styled.span `
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background-color: ${(props) => status[props.type || 'default']};
`;
export const Dot = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement(StyledDot, Object.assign({ className: cx('dot', className), "data-role": "dot" }, props));
};
